<template>
  <app-logged id="RelatoriosIndex">
    <v-flex xs12>
      <app-widget>
        <div slot="widget-content">
          <v-list two-line>
            <v-list-item
              v-for="(item, i) in listOfReports"
              :key="i"
              @click="goToReport(item.route)"
            >
              <v-list-item-avatar>
                <v-avatar
                  color="secondary"
                  size="40"
                >
                  <v-icon dark>
                    print
                  </v-icon>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="`${item.title}`" />
                <v-list-item-subtitle
                  class="grey--text"
                  v-text="`${item.subtitle}`"
                />
              </v-list-item-content>
              <v-list-item-action>
                <v-icon color="grey lighten-1">
                  arrow_forward_ios
                </v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </div>
      </app-widget>
    </v-flex>
  </app-logged>
</template>
<script>
import AppLogged from '@/components/layouts/AppLogged'
import AppWidget from '@/components/AppWidget'
import ordenedReports from '@/util/report'
export default {
  name: 'RelatoriosIndex',
  components: {
    AppLogged,
    AppWidget
  },
  data: () => {
    return {
      listOfReports: []
    }
  },
  created () {
    this.listOfReports = ordenedReports()
  },
  methods: {
    goToReport (name) {
      this.$router.push({
        name
      })
    }
  }
}
</script>
